import { Route, Routes } from "react-router-dom";
import "./App.css";
import Footer from "./Components/Footer/Footer";
import Header from "./Components/Header/Header";
import Home from "./Pages/Home/Home";
import Services from "./Pages/Services/Services";
import AboutUs from "./Pages/AboutUs/AboutUs";
import ContactUs from "./Pages/ContactUs/ContactUs";
import FloatingBtn from "./Components/floating-button/FloatingBtn";
import Buildings from "./Pages/DetailsOfLinks/Buildings/Buildings";
import Bridges from "./Pages/DetailsOfLinks/Bridges/Bridges";
import Infrastructure from "./Pages/DetailsOfLinks/Infrastructure/Infrastructure";
import Process from "./Pages/DetailsOfLinks/Process/Process";
import Treatments from "./Pages/DetailsOfLinks/Treatments/Treatments";

function App() {
  return (
    <div className="App">
      <Header />

      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/services" element={<Services />}></Route>
        <Route path="/aboutUs" element={<AboutUs />}></Route>
        <Route path="/contactUs" element={<ContactUs />}></Route>
        <Route path="/buildings" element={<Buildings />}></Route>
        <Route path="/bridges" element={<Bridges />}></Route>
        <Route path="/infrastructure" element={<Infrastructure />}></Route>
        <Route path="/process" element={<Process />}></Route>
        <Route path="/treatments" element={<Treatments />}></Route>
      </Routes>

      <FloatingBtn />

      <Footer />
    </div>
  );
}

export default App;
